module.exports = __webpack_public_path__ + "media/images/temp-closed-icon-0ad8aec4db2d5a3ba858f9ba711184c0.svg";